import React from 'react';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import { TYPE_COLORS } from '../../common/constants';
import fromPairs from 'lodash/fromPairs';
import flatten from 'lodash/flatten';

const typeStyles = fromPairs(
  flatten(
    TYPE_COLORS.map(entry => {
      const { key, ...value } = entry;
      return [
        [`${key}Background`, { background: value.bgColor }],
        [`${key}Label`, { color: value.color, fontSize: 'small' }],
        [`${key}Value`, { color: value.color }]
      ];
    })
  )
);
const styles = () => ({
  root: {
    width: 200,
    height: 55,
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '3fr 2fr'
  },
  label: {
    marginLeft: 20,
    fontSize: 11
  },
  justified: {
    justifySelf: 'end'
  },
  value: {
    fontSize: 18,
    marginRight: 10
  },
  ...typeStyles
});

const TargetBox = ({ classes, label, value, lighten, justified = false }) => {
  const { bgColor, lblColor, valColor, borderStyles } = React.useMemo(() => {
    const typeStyle = TYPE_COLORS.find(t => t.label === label);
    if (!typeStyle) throw `Error: Type Style with label "${label}" not found.`;
    const { key } = typeStyle;
    return {
      bgColor: `${key}Background`,
      lblColor: `${key}Label`,
      valColor: `${key}Value`,
      borderStyles: {
        opacity: lighten ? 0.65 : 1
        // border: `${color(typeStyle.color).alpha(0.5)} 2px solid`,
      }
    };
  }, [label, lighten]);
  return (
    <Paper
      elevation={0}
      className={classNames(classes.root, {
        [classes[bgColor]]: true
      })}
      style={borderStyles}>
      <div
        className={classNames(classes.label, {
          [classes[lblColor]]: true
        })}>
        {label}
      </div>
      <div
        className={classNames(classes.value, {
          [classes[valColor]]: true,
          [classes.justified]: justified
        })}>
        <NumberFormat
          displayType="text"
          decimalScale={2}
          value={value}
          prefix={label === 'GP$' ? '$' : ''}
          thousandSeparator
        />
      </div>
    </Paper>
  );
};

export default withStyles(styles)(TargetBox);
